import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

import {doAlert} from '@/util';
import {ref} from 'vue';
import {resetPassword} from '@/api/module/misc';
import {useSettings} from '@/store/settings';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props, { expose: __expose }) {

const mode = ref('login' as 'login' | 'reset');
const showPassword = ref(false);

const loading = ref(false);
const username = ref(process.env.NODE_ENV == 'development' ? 'demo@ncn.de' : '');
const password = ref(process.env.NODE_ENV == 'development' ? 'Abcd1234!' : '');
const settingsStore = useSettings();

async function doLogin() {
  console.log('login');
  await settingsStore.login(username.value, password.value);
}

async function doResetPassword() {
  await resetPassword(username.value);
  await doAlert('Passwort erfolgreich zurückgesetzt');
  mode.value = 'login';
}

async function performAction() {
  console.log('action');
  try {
    loading.value = true;
    mode.value === 'login' ? await doLogin() : await doResetPassword();
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loading.value = false;
  }
}

__expose({
  username,
  password,
  loading,
  performAction,
  mode,
  showPassword,
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (performAction()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            label: "E-Mail-Adresse",
            type: "email",
            modelValue: username.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
          }, null, 8, ["modelValue"]),
          (mode.value === 'login')
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 0,
                label: "Passwort",
                modelValue: password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                "append-inner-icon": !showPassword.value ? 'mdi-eye' : 'mdi-eye-off',
                "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
              }, null, 8, ["modelValue", "type", "append-inner-icon"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            block: "",
            color: "primary",
            loading: loading.value,
            disabled: loading.value,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mode.value === 'login' ? 'Anmelden' : 'Passwort zurücksetzen'), 1)
            ], undefined, true),
            _: 1
          }, 8, ["loading", "disabled"]),
          (mode.value !== 'reset')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                class: "mt-2",
                block: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (mode.value = 'reset')),
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Passwort zurücksetzen")
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          (mode.value !== 'login')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                class: "mt-2",
                block: "",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (mode.value = 'login')),
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Abbrechen")
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})